export default __webpack_public_path__ + "static/media/region-button.fcbba674.svg";